import React from 'react';

const HeaderSearchICon = () => (
  <svg
    width="56"
    height="32"
    viewBox="0 0 56 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_iii_2574_9121)">
      <rect width="56" height="32" rx="8" fill="white" />
      <path
        d="M16.3409 22.2557C15.8636 22.2557 15.428 22.1402 15.0341 21.9091C14.6402 21.6742 14.3258 21.3598 14.0909 20.9659C13.8561 20.5682 13.7386 20.1326 13.7386 19.6591C13.7386 19.178 13.8561 18.7405 14.0909 18.3466C14.3258 17.9527 14.6402 17.6383 15.0341 17.4034C15.428 17.1686 15.8636 17.0511 16.3409 17.0511H17.5227V15.3011H16.3409C15.8636 15.3011 15.428 15.1856 15.0341 14.9545C14.6402 14.7197 14.3258 14.4072 14.0909 14.017C13.8561 13.6231 13.7386 13.1856 13.7386 12.7045C13.7386 12.2273 13.8561 11.7917 14.0909 11.3977C14.3258 11.0038 14.6402 10.6913 15.0341 10.4602C15.428 10.2254 15.8636 10.108 16.3409 10.108C16.8182 10.108 17.2538 10.2254 17.6477 10.4602C18.0417 10.6913 18.3561 11.0038 18.5909 11.3977C18.8295 11.7917 18.9489 12.2273 18.9489 12.7045V13.8807H20.6932V12.7045C20.6932 12.2273 20.8087 11.7917 21.0398 11.3977C21.2746 11.0038 21.589 10.6913 21.983 10.4602C22.3769 10.2254 22.8144 10.108 23.2955 10.108C23.7727 10.108 24.2083 10.2254 24.6023 10.4602C24.9962 10.6913 25.3087 11.0038 25.5398 11.3977C25.7746 11.7917 25.892 12.2273 25.892 12.7045C25.892 13.1856 25.7746 13.6231 25.5398 14.017C25.3049 14.4072 24.9905 14.7197 24.5966 14.9545C24.2064 15.1856 23.7727 15.3011 23.2955 15.3011H22.1193V17.0511H23.2955C23.7727 17.0511 24.2064 17.1686 24.5966 17.4034C24.9905 17.6383 25.3049 17.9527 25.5398 18.3466C25.7746 18.7405 25.892 19.178 25.892 19.6591C25.892 20.1326 25.7746 20.5682 25.5398 20.9659C25.3049 21.3598 24.9905 21.6742 24.5966 21.9091C24.2064 22.1402 23.7727 22.2557 23.2955 22.2557C22.8144 22.2557 22.3769 22.1402 21.983 21.9091C21.589 21.6742 21.2746 21.3598 21.0398 20.9659C20.8087 20.5682 20.6932 20.1326 20.6932 19.6591V18.4716H18.9489V19.6591C18.9489 20.1326 18.8295 20.5682 18.5909 20.9659C18.3561 21.3598 18.0417 21.6742 17.6477 21.9091C17.2538 22.1402 16.8182 22.2557 16.3409 22.2557ZM16.3409 20.8352C16.5568 20.8352 16.7538 20.7822 16.9318 20.6761C17.1136 20.5701 17.2576 20.428 17.3636 20.25C17.4697 20.072 17.5227 19.875 17.5227 19.6591V18.4716H16.3409C16.125 18.4716 15.928 18.5265 15.75 18.6364C15.572 18.7424 15.4299 18.8845 15.3239 19.0625C15.2178 19.2405 15.1648 19.4394 15.1648 19.6591C15.1648 19.875 15.2159 20.072 15.3182 20.25C15.4242 20.428 15.5663 20.5701 15.7443 20.6761C15.9261 20.7822 16.125 20.8352 16.3409 20.8352ZM16.3409 13.8807H17.5227V12.7045C17.5227 12.4848 17.4697 12.2879 17.3636 12.1136C17.2576 11.9356 17.1136 11.7936 16.9318 11.6875C16.7538 11.5814 16.5568 11.5284 16.3409 11.5284C16.125 11.5284 15.928 11.5814 15.75 11.6875C15.572 11.7936 15.4299 11.9356 15.3239 12.1136C15.2178 12.2879 15.1648 12.4848 15.1648 12.7045C15.1648 12.9205 15.2159 13.1193 15.3182 13.3011C15.4242 13.4792 15.5663 13.6212 15.7443 13.7273C15.9261 13.8295 16.125 13.8807 16.3409 13.8807ZM22.1193 13.8807H23.2955C23.5114 13.8807 23.7083 13.8295 23.8864 13.7273C24.0644 13.6212 24.2045 13.4792 24.3068 13.3011C24.4129 13.1231 24.4659 12.9242 24.4659 12.7045C24.4659 12.4848 24.4129 12.2879 24.3068 12.1136C24.2045 11.9356 24.0644 11.7936 23.8864 11.6875C23.7083 11.5814 23.5114 11.5284 23.2955 11.5284C23.0758 11.5284 22.8769 11.5814 22.6989 11.6875C22.5208 11.7936 22.3788 11.9356 22.2727 12.1136C22.1705 12.2879 22.1193 12.4848 22.1193 12.7045V13.8807ZM23.2955 20.8352C23.5114 20.8352 23.7083 20.7822 23.8864 20.6761C24.0644 20.5701 24.2045 20.428 24.3068 20.25C24.4129 20.072 24.4659 19.875 24.4659 19.6591C24.4659 19.4394 24.4129 19.2405 24.3068 19.0625C24.2045 18.8845 24.0644 18.7424 23.8864 18.6364C23.7083 18.5265 23.5114 18.4716 23.2955 18.4716H22.1193V19.6591C22.1193 19.875 22.1705 20.072 22.2727 20.25C22.3788 20.428 22.5208 20.5701 22.6989 20.6761C22.8769 20.7822 23.0758 20.8352 23.2955 20.8352ZM18.9489 17.0511H20.6932V15.3011H18.9489V17.0511ZM33.7378 22C33.4818 22 33.2738 21.9253 33.1138 21.776C32.9644 21.616 32.8898 21.4187 32.8898 21.184V11.616C32.8898 11.3813 32.9698 11.1893 33.1298 11.04C33.2898 10.88 33.4818 10.8 33.7057 10.8H39.1138C39.3484 10.8 39.5404 10.8747 39.6898 11.024C39.8498 11.1733 39.9298 11.36 39.9298 11.584C39.9298 11.7867 39.8498 11.9627 39.6898 12.112C39.5404 12.2613 39.3484 12.336 39.1138 12.336H34.4418L34.5538 12.176V15.744L34.4578 15.552H38.3938C38.6284 15.552 38.8204 15.6267 38.9698 15.776C39.1298 15.9253 39.2098 16.112 39.2098 16.336C39.2098 16.5387 39.1298 16.7147 38.9698 16.864C38.8204 17.0133 38.6284 17.088 38.3938 17.088H34.4258L34.5538 16.96V21.184C34.5538 21.4187 34.4738 21.616 34.3138 21.776C34.1538 21.9253 33.9618 22 33.7378 22Z"
        fill="#767476"
      />
    </g>
    <defs>
      <filter
        id="filter0_iii_2574_9121"
        x="0"
        y="-1"
        width="56"
        height="33"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2574_9121"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_innerShadow_2574_9121"
          result="effect2_innerShadow_2574_9121"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="multiply"
          in2="effect2_innerShadow_2574_9121"
          result="effect3_innerShadow_2574_9121"
        />
      </filter>
    </defs>
  </svg>
);

export default HeaderSearchICon;
